import React, { useState } from 'react';
import PropTypes from 'prop-types';

// redux
import { useDispatch, useSelector } from 'react-redux';
import {
	setIngredientComponentTranslation,
	updateIgredientComponentTranslation,
	resetState,
} from './store/ingredientComponentTranslations.actions';

// components
import { ReactDataWrapper } from 'reactDataWrapper';
import IngredientComponentTranslationsModalBatch from './components/batch/ingredientComponentTranslationsModalBatch';
import { Tooltip, Icon, Button, Input } from 'dumb';

// services
import {
	fetchAllIngredientComponentTranslations,
	deleteIngredientComponentTranslation,
	editIngredientComponentTranslation,
} from './ingredientComponentTranslations.service';

// utils
import { getEditedValues } from 'services/utils';

// phrases
import phrases from './ingredientComponentTranslations.phrases';

const columns = [
	{
		Header: 'Name',
		id: 'name',
		accessor: 'name',
		filterPath: ':name',
	},
	{
		Header: 'Language',
		id: 'language',
		accessor: 'language.name',
		filterPath: ':language.name',
	},
];

const IngredientComponentTranslation = ({ id }) => {
	const dispatch = useDispatch();
	const { tableKey, ingredientComponentTranslation, originalIngredientComponentTranslation } = useSelector(
		(store) => store.ingredientComponentTranslations
	);

	const [showBatchModal, setShowBatchModal] = useState(false);

	// crud
	const fetchData = (state) => fetchAllIngredientComponentTranslations(id, state);
	const editEntry = () => {
		const valuesToEdit = getEditedValues({
			newData: ingredientComponentTranslation,
			oldData: originalIngredientComponentTranslation,
		});

		const payload = {
			id: ingredientComponentTranslation.id,
			name: valuesToEdit.name,
		};

		return editIngredientComponentTranslation(payload);
	};
	const deleteEntry = (id) => deleteIngredientComponentTranslation(id);

	// crud prep
	const setInitialEditValues = (data) => {
		const body = {
			id: data.id,
			name: data.name,
			language: data.language.name,
		};

		dispatch(setIngredientComponentTranslation(body));
	};
	const getEditableCells = () => [
		{
			header: 'Name',
			value: (
				<Input
					id="name"
					placeholder={phrases.NAME}
					value={ingredientComponentTranslation.name}
					onChange={(event) => dispatch(updateIgredientComponentTranslation({ name: event.target.value }))}
				/>
			),
		},
		{
			header: 'Language',
			value: <span>{ingredientComponentTranslation.language}</span>,
		},
	];

	const toggleBatchModal = () => setShowBatchModal(!showBatchModal);
	const onRdwModalClose = () => dispatch(resetState());

	return (
		<>
			<ReactDataWrapper
				key={tableKey}
				accessAreasAllowedToEdit={['Sales Configuration']}
				title={phrases.TITLE}
				columns={columns}
				fetchData={fetchData}
				filterable
				defaultPageSize={10}
				reduxKey={`${id}-product/ingredient_component_translations`}
				manual
				editableCells={getEditableCells()}
				setInitialEditValues={setInitialEditValues}
				onModalClose={onRdwModalClose}
				deleteEntry={deleteEntry}
				editEntry={editEntry}
				actionRender={
					<Tooltip
						text={phrases.BATCH_ADD}
						renderData={(ref, onMouseEnter, onMouseLeave) => (
							<Button
								label="Add"
								shadow
								type="inverted"
								onClick={toggleBatchModal}
								refProp={ref}
								onMouseEnter={onMouseEnter}
								onMouseLeave={onMouseLeave}
							>
								<Icon name="add" />
							</Button>
						)}
					/>
				}
			/>

			{showBatchModal && <IngredientComponentTranslationsModalBatch onClose={toggleBatchModal} allergenId={id} />}
		</>
	);
};

IngredientComponentTranslation.propTypes = {
	id: PropTypes.number,
};

export default IngredientComponentTranslation;
